const o={dark:"dark",light:"light"},l={small:"small",large:"large"};export{o as themes,l as variants};
//# sourceMappingURL=text-input.types.js.map
